<template>
  <div class="popup_wrap">
    <span @click="openCouponModal">
      <slot />
    </span>
    <!-- 레이어팝업 -->
    <modal @close="closeModal" :open="modal.open" title="쿠폰 선택">
      <p class="colorbox mb20">복지 할인이 선택된 경우 쿠폰 할인이 적용되지 않아 결제 금액이 달라질 수 있습니다.</p>
      <dl class="mb10" v-for="coupon in couponList" :key="coupon.couponsaleSeq">
        <a @click="() => onCouponClick(coupon.couponsaleSeq, coupon.cart)">
          <dd class="colorBox">
            <div v-if="coupon.cart" style="text-align: center">체험바구니에 이미 사용된 쿠폰입니다.</div>
            <div class="coupon" :class="{ used: coupon.cart }">
              <input type="radio" :value="coupon.couponsaleSeq" v-model="selected" ref="" style="appearance: auto" :disabled="coupon.cart" />
              <span style="width: 80px">-{{ _priceFormat(coupon.couponDcPrice) }}원</span>
              <span>
                {{ coupon.note }}
                <br />
                (사용기간: {{ coupon.useStartDt }} ~ {{ coupon.useEndDt }})
              </span>
              <span><a v-if="coupon.couponsaleSeq === selected" @click="onCancelCouponClick">선택취소</a></span>
            </div>
          </dd>
        </a>
      </dl>
      <dl v-if="couponList.length < 1">
        <dd class="colorBox">사용가능한 쿠폰이 없습니다.</dd>
      </dl>
      <!-- /default -->
      <!-- footer 슬롯 콘텐츠 -->
      <template slot="footer">
        <div class="btn_wrap">
          <a class="all-half btn btn_bg gray" @click="closeModal">취소</a>
          <a class="all-half btn btn_bg color" @click="onConfirmClick">적용</a>
        </div>
      </template>
      <!-- /footer -->
    </modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { isLoggedIn } from '@/utils/reserve';
import { getCouponList } from '@/api/api_reserve';
import Modal from '@/components/common/Modal.vue';

export default {
  components: { Modal },
  props: ['value', 'booking'],
  data() {
    return {
      modal: {
        open: false,
      },
      selected: 0,
      couponList: [],
    };
  },
  computed: {
    ...mapGetters(['usedCouponList']),
  },
  watch: {
    'modal.open': function (to) {
      if (to) {
        this.getCartItems(this.groupPersDiv);
        getCouponList(this.booking).then((data) => {
          if (data.success) {
            const couponList = data.response.couponList;
            couponList.forEach((coupon) => {
              coupon.cart = this.usedCouponList.includes(coupon.couponsaleSeq);
            });
            this.couponList = couponList;
          }
        });
      }
    },
  },
  methods: {
    ...mapActions('reserve', ['editReserveInfo']),
    ...mapActions(['getCartItems']),
    openModal() {
      this.modal.open = true;
    },
    closeModal() {
      this.modal.open = false;
    },
    openCouponModal() {
      if (isLoggedIn()) {
        if (this.booking?.includeList?.length > 0) {
          this.openModal();
        } else {
          alert('체험자를 먼저 선택해 주세요');
        }
      }
    },
    onCouponClick(key, cart) {
      if (!cart) {
        this.selected = key;
      }
    },
    onCancelCouponClick(e) {
      e.stopPropagation();
      this.selected = 0;
      //this.cancel();
    },
    onConfirmClick() {
      const coupon = this.couponList.find((e) => e.couponsaleSeq === this.selected);
      if (coupon?.coupontypDiv === '99') {
        this.editReserveInfo({ coupon });
      } else {
        this.editReserveInfo({ coupon: null });
      }

      if (coupon) {
        let pesnDivFlag = this.booking?.includeList.some((e) => e.pesnDivCd !== '01') || this.booking?.leaderList.some((e) => e.pesnDivCd !== '01');
        if (pesnDivFlag) {
          alert('복지할인이 적용되지 않은 인원에만 쿠폰이 적용됩니다.');
        }
      }
      //최대 할인 비교
      /*
          let notSaleExper = [];
          let notSaleLeader = [];
          if (state.experPcntList.some((e) => e.price > 0 && e.orgPrice != e.price)) {
            notSaleExper = state.experPcntList.map((e) => {
              let pesnDivCd = e.pesnDivCd;
              if (e.price > 0 && e.orgPrice != e.price) {
                pesnDivCd = '01';
              }
              return {
                ...e,
                pesnDivCd,
              };
            });
          }
          if (state.leaderPcntList.some((e) => e.price > 0 && e.orgPrice != e.price)) {
            notSaleLeader = state.leaderPcntList.map((e) => {
              let pesnDivCd = e.pesnDivCd;
              if (e.price > 0 && e.orgPrice != e.price) {
                pesnDivCd = '01';
              }
              return {
                ...e,
                pesnDivCd,
              };
            });
          }
          */

      this.$emit('input', this.selected);
      this.closeModal();
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
::v-deep .modal.modal-overlay {
  display: flex;
  justify-content: center;
  align-items: center;

  & .pop_layer {
    max-width: 600px;
    left: initial;
    top: initial;
    margin-top: 0;
    margin-left: 0;

    & .pop_titbox {
      position: initial;
    }

    & .pop_cont {
      margin-top: 0;
    }
  }
}
.popup_wrap {
  display: inline-block;
  & a {
    cursor: pointer;
  }
  & .checkbox input[type='checkbox'] + label {
    font-size: 16px;
    display: inline-block;
    height: 19px;
    padding-left: 23px;
    line-height: 19px;
    background-size: 19px 19px;
    width: initial;
  }
}

.coupon {
  display: flex;
  gap: 10px;
  align-items: center;
  &.used {
    color: #888;
  }
}
</style>
